// หน้า list เก็บแค่ business_unit_ref_id ต้อง map เป็นชื่อเองจาก list business unit
// ควรส่ง list ที่รวม BU ที่ถูกลบแล้วมาด้วย ไม่งั้นรายการเก่าที่ผูก BU ที่ลบไปจะขึ้น "-"
export const BUSINESS_UNIT_MAP = (docs) =>
  (docs || []).reduce((result, e) => {
    result[e._id] = e.name;
    return result;
  }, {});

export const RENDER_BUSINESS_UNIT_NAME = (businessUnitMap, id) =>
  (id && businessUnitMap && businessUnitMap[id]) || "-";

// dropdown ในหน้าสร้าง/แก้ไข ใช้ "null" แทน "ไม่ผูก BU" เพราะ react-dropdown ใช้ค่า null ไม่ได้
// ตอน submit ต้องแปลงกลับเป็น null ก่อนส่ง API
export const BUSINESS_UNIT_FORM_OPTIONS = (docs) => [
  { label: "None", value: "null" },
  ...(docs || []).map((e) => ({
    label: e.name,
    value: e._id,
  })),
];
